// src/lib/presence-tracker.js
// «Активен» = вкладка видима И было действие за последние idleMs (по умолчанию 60с).
// Ядро не зависит от DOM — getNow/isHidden/send инъектируются (для тестов).
export function createPresenceTracker({
  idleMs = 60000,
  checkMs = 10000,
  getNow = () => Date.now(),
  isHidden = () => (typeof document !== 'undefined' && document.hidden),
  send,
} = {}) {
  let lastActivity = getNow();
  let lastSent = null;     // null = ещё не слали
  let intervalId = null;
  let listeners = [];

  function computeActive() {
    return !isHidden() && (getNow() - lastActivity) < idleMs;
  }
  function emit(active) {
    if (active !== lastSent) { lastSent = active; try { send && send(active); } catch {} }
  }
  function recompute() { emit(computeActive()); }
  function noteActivity() { lastActivity = getNow(); if (lastSent !== true) recompute(); }
  function flush() { lastSent = null; recompute(); }   // форс-переотправка текущего

  function start() {
    if (typeof window === 'undefined' || intervalId) return;
    const onAct = () => noteActivity();
    const onVis = () => { if (isHidden()) recompute(); else noteActivity(); };
    ['mousemove', 'mousedown', 'keydown', 'scroll', 'wheel', 'touchstart'].forEach(ev => {
      window.addEventListener(ev, onAct, { passive: true });
      listeners.push([ev, onAct]);
    });
    document.addEventListener('visibilitychange', onVis);
    listeners.push(['visibilitychange', onVis, true]);
    intervalId = setInterval(recompute, checkMs);
    recompute();
  }
  function stop() {
    listeners.forEach(([ev, fn, onDoc]) => (onDoc ? document : window).removeEventListener(ev, fn));
    listeners = [];
    if (intervalId) { clearInterval(intervalId); intervalId = null; }
  }

  return { start, stop, noteActivity, recompute, flush, getActive: computeActive };
}
